export enum widgetTypes {
  NORMAL = 'normal',
  SECURE = 'secure',
  SSO = 'sso',
  NOTICEBOARD = 'noticeboard',
  IFRAME = 'iframe',
}
